import { useMemo } from 'react'

import { useQuery } from '@tanstack/react-query'

import { AIPlatformAPI } from 'api/index'
import { Scenario } from 'layouts/ConversationsDetailReport/components/MessageReview/types'

export interface IScenarioOption {
  label: string
  value: string
}

export const useExposedScenarios = () => {
  const { data: scenarios = [] } = useQuery<Scenario[]>({
    queryKey: ['exposedScenarios'],
    queryFn: async () => {
      try {
        const response = await AIPlatformAPI.get<Scenario[]>(
          'api/v1/scenarios/org/review'
        )
        return response.data
      } catch (error) {
        console.error('Error fetching scenarios:', error)
        throw error
      }
    },
    staleTime: 60000,
  })

  const exposedScenarioOptions: IScenarioOption[] = useMemo(() => {
    return scenarios
      .filter((scenario) => scenario.exposed)
      .map((scenario) => ({
        label: scenario.name,
        value: String(scenario.scenarioId),
      }))
  }, [scenarios])

  return exposedScenarioOptions
}

export default useExposedScenarios
